import { Intersection, Material, MeshBasicMaterial, Object3D, SphereGeometry, Vector3, Mesh as ThreeMesh } from 'three';
import { threeStore } from '@modules/three/store/threeStore.ts';
import { Mesh } from '@modules/three/common/mesh';
import RaycastEvents from '../../raycastEvents';
import InteractiveSpline from './InteractiveSpline';
import {
  createControlPointHalo,
  disposeMaterial,
  SEGMENTATION_VISUAL,
} from '@modules/three/common/visual/segmentationVisuals';

export default class SplineControlPoint extends Mesh implements RaycastEvents {
  private interactiveSpline: InteractiveSpline;
  private indexInSpline: number;
  private snappedPoint: SplineControlPoint | null = null;
  private haloMesh: ThreeMesh;

  constructor(position: Vector3, radius: number, interactiveSpline: InteractiveSpline, indexInSpline: number) {
    super(
      new SphereGeometry(radius),
      new MeshBasicMaterial({ color: SEGMENTATION_VISUAL.controlPointCore }),
    );
    this.position.copy(position);
    this.interactiveSpline = interactiveSpline;
    this.indexInSpline = indexInSpline;

    this.haloMesh = createControlPointHalo();
    this.add(this.haloMesh);

    threeStore.getState().rootState.scene.add(this);
  }

  public raycastHit(_intersection: Intersection<Object3D>): void {
    this.interactiveSpline.onPointerDown(this);
  }

  public getIndexInSpline(): number {
    return this.indexInSpline;
  }

  public setIndexInSpline(index: number): void {
    this.indexInSpline = index;
  }

  public getInteractiveSpline(): InteractiveSpline {
    return this.interactiveSpline;
  }

  public setSnappedPoint(point: SplineControlPoint | null): void {
    this.snappedPoint = point;
  }

  public getSnappedPoint(): SplineControlPoint | null {
    return this.snappedPoint;
  }

  /** Removes this control point from the scene and clears any snap pairing. */
  public destroy(): void {
    const partner = this.snappedPoint;
    if (partner) {
      partner.setSnappedPoint(null);
      partner.getInteractiveSpline().updateLine();
    }
    this.snappedPoint = null;

    this.haloMesh.geometry.dispose();
    disposeMaterial(this.haloMesh.material);
    this.geometry.dispose();
    disposeMaterial(this.material as Material);

    threeStore.getState().rootState.scene.remove(this);
  }
}
